import { injectIntl } from "react-intl";
import apiService from "src/services/api.service";

const ResetScore = (props) => {
  const resetScore = () => {
    apiService.resetOfferScore(props.offerId).then(() => props.closeModal());
  };

  return (
    <div className="NewStrategyModalOverlay z-[999]">
      <div className="DeleteStrategyModal">
        <div className={"w-full flex justify-between"}>
          <div className={"NewStrategy"}>
            <img
              alt={"Logo"}
              src={"/media/icons/warningPurple.svg"}
              className={"w-[18px] h-[18px]"}
            />
            Are You Sure You Want to Delete This Offer?
          </div>
          <button className={"CloseIconButton"} onClick={props.closeModal}>
            <img
              alt={"Logo"}
              src={"/media/icons/closeIcon.svg"}
              className={"w-5 h-5"}
            />
          </button>
        </div>
        <div className={"flex flex-col gap-4 w-full"}>
          <div className={"HorizontalDivider"}></div>
          <div className={"StrategyDeleteWarning"}>
            Are you sure you want to reset the score for “{props.name}”? This
            action cannot be undone.
          </div>
          <div className={"HorizontalDivider"}></div>
        </div>
        <div className={"modal-actions"}>
          <button className={"CloseButton"} onClick={props.closeModal}>
            Cancel
          </button>
          <button className={"CreateButton"} onClick={resetScore}>
            Yes, Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(ResetScore);
